export default __webpack_public_path__ + "static/media/2012-228x228.ae8468bf.png";